import React from "react";
import { Layout, Typography } from "antd";

const { Title } = Typography;
//function used to show unauthorized users that they are not authorized to view the application
function NotAuthorized() {
    return (
        <Layout className="login-layout">
            <div className="login-wrapper">
                <div className="login-form-wrap">
                    <div>
                        <Title
                            className="welcome-text"
                            level={1}
                            style={{ textAlign: "center" }}
                        >
                            Hello! <br />You are not authorized to access this application.
                            <br />
                        </Title>

                        <Title
                            className="welcome-text"
                            level={4}
                            style={{ textAlign: "center" }}
                        >
                            Get in touch with Admin for further info.
                            <br />
                            Thank You.
                        </Title>
                    </div>
                </div>
                <div className="login-bg" />
            </div>
        </Layout>
    );
}

export default NotAuthorized;